/**
 * STATISCHE PAGINA'S - centrale configuratie
 * ============================================
 * Voeg hier een nieuwe pagina toe om hem automatisch:
 *   ✓ als route te registreren (router.js leest dit bestand)
 *   ✓ in de sitemap.xml op te nemen (server.js leest dit bestand)
 *   ✓ door de cache-warmer te laten opwarmen (via sitemap)
 *
 * HOE EEN NIEUWE PAGINA TOEVOEGEN:
 * 1. Maak een component aan in src/pages/  (bijv. MijnPagina.vue)
 * 2. Voeg hieronder een object toe met path, meta en component
 * 3. Klaar - route, sitemap en cache worden automatisch bijgewerkt
 *
 * Velden:
 *   path        - URL (bijv. '/installatie')
 *   name        - unieke routenaam (bijv. 'installatie')
 *   title       - <title> tag voor SEO
 *   description - meta description (max ~155 tekens)
 *   keywords    - comma-separated zoekwoorden
 *   priority    - sitemap prioriteit (0.0 – 1.0)
 *   changefreq  - sitemap wijzigingsfrequentie
 *   component   - lazy-loaded Vue component
 */

export const STATIC_PAGES = [
  {
    path:        '/installatie',
    name:        'installatie',
    title:       'Zonnepanelen installeren: Tips & Tricks + Installatieservice | Plug2Charge.nl',
    description: 'Leer hoe je balkonzonnepanelen zelf installeert in 5 stappen. Kom je er niet uit? Vraag onze professionele installatieservice aan.',
    keywords:    'zonnepanelen installeren, balkon zonnepanelen installatie, micro-omvormer aansluiten, installatieservice, plug en play',
    priority:    '0.8',
    changefreq:  'monthly',
    component:   () => import('../pages/Installatie.vue'),
  },

  {
    path:        '/retourneren',
    name:        'retourneren',
    title:       'Retourneren: 30 Dagen Bedenktijd & Gratis Retour | Plug2Charge.nl',
    description: 'Niet tevreden? 30 dagen bedenktijd, gratis retour en geld terug binnen 5 werkdagen. Lees ons volledige retourbeleid.',
    keywords:    'retourneren, retourbeleid, gratis retour, bedenktijd, geld terug, plug2charge',
    priority:    '0.7',
    changefreq:  'monthly',
    component:   () => import('../pages/Retourneren.vue'),
  },

  // ── Informatieve pagina's ────────────────────────────────────────────────────

  {
    path:        '/over-ons',
    name:        'over-ons',
    title:       'Over Plug2Charge | Specialist in zonne-energie & laadpalen',
    description: 'Leer meer over Plug2Charge - onze missie, producten en belofte aan klanten.',
    keywords:    'over ons, plug2charge, zonne-energie specialist, laadpalen',
    priority:    '0.6',
    changefreq:  'monthly',
    component:   () => import('../pages/OverOns.vue'),
  },

  {
    path:        '/contact',
    name:        'contact',
    title:       'Contact | Plug2Charge.nl',
    description: 'Neem contact op met Plug2Charge. Bereikbaar via e-mail of live chat.',
    keywords:    'contact, klantenservice, plug2charge, e-mail, live chat',
    priority:    '0.6',
    changefreq:  'monthly',
    component:   () => import('../pages/Contact.vue'),
  },

  {
    path:        '/verzending',
    name:        'verzending',
    title:       'Verzending & Retour | Plug2Charge.nl',
    description: 'Gratis verzending vanaf €50. Bestel vóór 15:00 = morgen in huis. 30 dagen retourrecht.',
    keywords:    'verzending, retour, levering, bezorging, plug2charge',
    priority:    '0.7',
    changefreq:  'monthly',
    component:   () => import('../pages/Verzending.vue'),
  },

  // ── Juridische pagina's ──────────────────────────────────────────────────────

  {
    path:        '/privacy',
    name:        'privacy',
    title:       'Privacybeleid | Plug2Charge.nl',
    description: 'Lees ons privacybeleid. Wij gaan zorgvuldig om met jouw persoonsgegevens conform de AVG.',
    keywords:    'privacy, privacybeleid, AVG, GDPR, persoonsgegevens, plug2charge',
    priority:    '0.4',
    changefreq:  'yearly',
    component:   () => import('../pages/Privacy.vue'),
  },

  {
    path:        '/cookies',
    name:        'cookies',
    title:       'Cookiebeleid | Plug2Charge.nl',
    description: 'Informatie over het gebruik van cookies op plug2charge.nl.',
    keywords:    'cookies, cookiebeleid, tracking, analytics, plug2charge',
    priority:    '0.3',
    changefreq:  'yearly',
    component:   () => import('../pages/Cookies.vue'),
  },

  {
    path:        '/disclaimer',
    name:        'disclaimer',
    title:       'Disclaimer | Plug2Charge.nl',
    description: 'Lees onze disclaimer over het gebruik van plug2charge.nl en de aansprakelijkheid.',
    keywords:    'disclaimer, aansprakelijkheid, intellectueel eigendom, plug2charge',
    priority:    '0.3',
    changefreq:  'yearly',
    component:   () => import('../pages/Disclaimer.vue'),
  },
]
